import {
  Content,
  ContentAccessUser,
  ContentNode,
  ReviewRequestStatus,
  UserProfile,
  InlineComment,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { ViewerType } from '../../model/Enum';
import { APGLEntityEntry } from '@amzn/awscat-editor';

interface ContentViewerContextData {
  isEditingEnabled: boolean;
  content?: Content;
  currentPage?: ContentNode;
  addNewPage?: (newPage: ContentNode, parentNode?: ContentNode) => void;
  addNewSection?: () => void;
  changeCurrentPage?: (selectedPage: ContentNode, depth: number) => void;
  updateContent?: (updatedContent: Content) => void;
  owner?: UserProfile;
  coAuthors?: ContentAccessUser[];
  peerReviewers?: ContentAccessUser[];
  viewerType?: ViewerType;
  reviewRequestStatus?: ReviewRequestStatus;
  inlineComments?: InlineComment[];
  contentId?: string;
  workflowId?: number;
  createInlineComment?: (
    path: string[],
    from: number,
    to: number,
    textData: string,
    commentData: string,
  ) => Promise<void>;
  updateInlineCommentsLocation?: (comments: InlineComment[], sectionId: string) => void;
  publicationState?: WorkflowState;
  isCommentingModeEnabled?: boolean;
  enableCommentMode?: (enabled: boolean) => void;
  reFetchInlineComments?: () => Promise<void>;
}

// @ts-expect-error TS2345 - strict migration
const ContentViewerContext = React.createContext<ContentViewerContextData>(undefined);

function withContentViewerContext(Component: any) {
  return (props: any) => {
    return (
      <ContentViewerContext.Consumer>
        {(ctx) => <Component {...props} contentViewerContext={ctx} />}
      </ContentViewerContext.Consumer>
    );
  };
}

export { ContentViewerContext, withContentViewerContext };
export type { ContentViewerContextData };
